import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getAddressSuggestions } from './api/getAddressSuggestions';
import { AddressSuggestion } from './api/models';

/** Short queries match far too much to be worth a lookup. */
export const MIN_ADDRESS_QUERY_LENGTH = 3;

/** Length ignores surrounding space, which the service reads but is not text. */
export const isValidAddressQuery = (query: string) =>
    query.trim().length >= MIN_ADDRESS_QUERY_LENGTH;

/** Shared with one-off lookups, so they hit the hook's cache. */
export const addressSuggestionsQuery = (query: string) => ({
    queryKey: ['addressAutocomplete', query],
    queryFn: async () => getAddressSuggestions(query),
    retry: false,
});

export const useAddressAutocomplete = (query: string) =>
    useQuery<Array<AddressSuggestion>>({
        ...addressSuggestionsQuery(query),
        // Keep the previous list while the next loads, so refining does not empty it.
        placeholderData: keepPreviousData,
        refetchOnMount: false,
        enabled: isValidAddressQuery(query),
        refetchOnWindowFocus: false,
    });
